import { Module } from '../Module';

Module.instance().directive('tbMouseCapture', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        // TODO: namespace can come from component using this directive.
        const eventNamespace = '.tbMouseCapture';

        // Note: $parse(attr[]) is the pattern used by angular directives. Not a binding.
        const moveFn = $parse(attr['tbMouseCapture']);
        const downFn = $parse(attr['tbMouseCaptureDown']);
        const upFn = $parse(attr['tbMouseCaptureUp']);

        const doc = angular.element(document);

        element.on('mousedown' + eventNamespace, (downEvent: JQuery.Event) => {

          // create an invisible overlay element to prevent other events (such as hover)
          // from triggering digests while mousedown.  We'll remove this on mouseup.
          const fillDiv = angular.element('<div>').addClass('tb-fill').appendTo(document.body);

          // apply the mousedown fn.
          scope.$apply(() => {
            downFn(scope, { $event: downEvent });
          });

          // register the mousemove fn.
          doc.on('mousemove' + eventNamespace, (moveEvent: JQuery.Event) => {
            moveFn(scope, { $event: moveEvent });
          });

          // register the mouseup fn.
          doc.on('mouseup' + eventNamespace, (upEvent: JQuery.Event) => {
            fillDiv.remove();
            doc.off(eventNamespace);
            scope.$apply(() => {
              upFn(scope, { $event: upEvent });
            });
          });

        });
      }
    };
  }
]);
